export default __webpack_public_path__ + "static/media/svg-3.4b854757.svg";